import { FC, PropsWithChildren, ReactElement } from 'react';
import { Replay } from '@mui/icons-material';

import { Button } from '@3.0/Buttons';
import cn from 'utils/cn';

export type TEmptyListSectionProps = {
  label?: string;
  className?: string;
  style?: React.CSSProperties;
  showRetry?: boolean;
  retryFn?: () => void;
} & PropsWithChildren;

const EmptyListSection: FC<TEmptyListSectionProps> = ({
  label,
  className,
  children,
  style,
  showRetry = false,
  retryFn,
}): ReactElement<any> => {
  return (
    <section
      aria-label={label}
      className={cn(
        `tw:font-light tw:bg-secondary-600/75 tw:text-primary-100 tw:flex tw:h-full tw:w-full tw:py-[40px]`,
        showRetry ? 'tw:flex-col tw:items-center' : 'tw:justify-center',
        className
      )}
      style={{
        ...style,
      }}
    >
      {children || label}
      {showRetry && (
        <>
          <Button
            testId="retry-button"
            variant="transparent"
            className="tw:!text-primary-100 tw:h-[68px]"
            label={
              <div className="tw:flex tw:flex-col tw:justify-center tw:items-center">
                <Replay className="tw:scale-x-[-1]" style={{ fontSize: 40 }} />
                <span className="tw:text-sm tw:font-light tw:mt-2">Retry</span>
              </div>
            }
            onClick={() => {
              if (retryFn) {
                retryFn();
              }
            }}
          ></Button>
          <div className="tw:text-sm tw:font-light tw:pt-7">
            If problem persists, please contact your system administrator.
          </div>
        </>
      )}
    </section>
  );
};

export default EmptyListSection;
